// Webpack Imports
import * as bootstrap from 'bootstrap';

( function () {
	'use strict';
	
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	}

	window.onload = () => {

		//$('#donorModal').modal('show');
		//jQuery('#supportModal').modal('show');
		
		$(document).on('gform_page_loaded', function(event, form_id, current_page){
			// code to be trigger when next/previous page is loaded

			/**
			* Donor Form
			*/
			
			if ($('#gform_' + form_id).hasClass( "donor-form" )) {
				// Focuses on the first input field.
				$('#gform_page_' + form_id + '_' + current_page).find('.gfield input').first().focus();
				//console.log('current_page: ', current_page);

				$('#gform_page_' + form_id + '_' + current_page + ' .gform_next_button').click(function() { 
					continue_btn_hooks($(this, form_id, current_page));
				});
			}
			
		});

		$(window).load( function() {
			// hello worldz
		});

		$(document).ready( function() {

			// Catches the first button of the donor form
			var donor_form_id = $('.donor-form').attr('id').replace('gform_', '');
			
			$('#gform_page_' + donor_form_id + '_1 .gform_next_button').click(function() { 
				continue_btn_hooks($(this), donor_form_id, 1);
			});
		});

		
		function continue_btn_hooks(btn, form_id, current_page) {
			console.log('Form ID:'+form_id+'\nPage'+current_page+'\nButton Clicked: ', btn.val());
			
			btn.fadeOut( "slow", function() {
				btn.fadeIn( "slow", function() {
					// Animation complete.
				});
			});

			$('<div class="row"><div class="col-12"><div class="lds-ripple page_'+current_page+' clearfix"><div></div><div></div></div></div></div>').insertBefore('.gform_page_footer');
		}

		/**
		 * Read More
		 */
		var read_more_html = '<div class="gfield_description"><div class="minimize-overview-gradient show-minimize-gradient"></div><div class="more-about-minimize-link"><div class="more-about-minimize-text"><span class="more-about-minimize-more-less">Read More</span>&nbsp;<span class="more-about-minimize-arrow arrow-down"><i class="fa-solid fa-chevron-up"></i><i class="fa-solid fa-chevron-down"></i></span></div></div></div>';

		$(read_more_html).insertAfter('.gfield__legal .ginput_container_textarea, .gfield__legal .gfield__legal__wrap');

		$('.more-about-minimize-text').click(function () {
			var $text = $(this).find(".more-about-minimize-more-less")
			//var $content = $(".minimize-overview-content");
			var $arrow = $(this).find(".more-about-minimize-arrow");
			var $parent_el = $(this).parents(".gfield");
			var $textarea_el = $parent_el.find("textarea");
			
			console.log('$textarea_el :>> ', $textarea_el);
			if ($textarea_el.length == 0) {
				console.log('NEGATIVE TEXT AREA :>> ', $textarea_el);
				$textarea_el = $parent_el.find(".gfield__legal__wrap");
			}

			var $gradient = $parent_el.find(".minimize-overview-gradient");

			var linkText = $text.text().toUpperCase();

			if (linkText === "READ MORE") {
				linkText = "Read Less";
				$gradient.addClass("d-none");

				$arrow.removeClass("arrow-down");
				$arrow.addClass("arrow-up");
				$textarea_el.addClass("expanded");
			} else {
				linkText = "Read More";
				$gradient.removeClass("d-none");

				$arrow.removeClass("arrow-up");
				$arrow.addClass("arrow-down");
				$textarea_el.removeClass("expanded");
			}
			$text.text(linkText);
		});
		/**
		* END -- Read More
		*/
	}

	

	var arrayElement = [];

	// Focus input if Searchform is empty
	arrayElement.forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	});	

	function play_video() {
		var player = document.getElementById("vimeovid1");
		var data = { method: "play" };
		player.contentWindow.postMessage(JSON.stringify(data), "*");
	}

} )();